import type { ZipDownloadPath } from "@/features/sub-families/types";
import { loosePostRequestBuilder } from "@/lib/fetcher.ts";
import type { Locale, Nullable, SiteEnum } from "@/types";

export default async function downloadFiles(
    url: ZipDownloadPath,
    smartNumber: Nullable<string>,
    site: SiteEnum,
    locale: Locale,
) {
    if (!smartNumber) throw new Error("Cannot download files when no smart number is present!");

    const resourceUrl = new URL(url);
    resourceUrl.searchParams.set("smartnumber", smartNumber);

    const requester = loosePostRequestBuilder(site, locale);

    const data = await requester<ApiSuccess, ApiError>(resourceUrl);

    if (!data.success) throw new Error("Failed downloading zip. Try again later");

    return data.link;
}

type ApiSuccess = { link: string };
type ApiError = Record<string, unknown>;
